// extracted by mini-css-extract-plugin
export default {"Container":"MarkSample_Container__fMNKl","List":"MarkSample_List__I9sPk","Columns":"MarkSample_Columns__Ly5sa","Column":"MarkSample_Column__s2AJ9"};